/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VilkarRouteImport } from './routes/vilkar'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PersonvernRouteImport } from './routes/personvern'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileCardsRouteImport } from './routes/profile.cards'
import { Route as CardsCallbackRouteImport } from './routes/cards.callback'
import { Route as HouseholdsHouseholdIdTabRouteImport } from './routes/households.$householdId.$tab'
import { Route as HouseholdsHouseholdIdSettlementsSettlementIdRouteImport } from './routes/households.$householdId.settlements.$settlementId'

const VilkarRoute = VilkarRouteImport.update({
  id: '/vilkar',
  path: '/vilkar',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonvernRoute = PersonvernRouteImport.update({
  id: '/personvern',
  path: '/personvern',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileCardsRoute = ProfileCardsRouteImport.update({
  id: '/profile/cards',
  path: '/profile/cards',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsCallbackRoute = CardsCallbackRouteImport.update({
  id: '/cards/callback',
  path: '/cards/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const HouseholdsHouseholdIdTabRoute =
  HouseholdsHouseholdIdTabRouteImport.update({
    id: '/households/$householdId/$tab',
    path: '/households/$householdId/$tab',
    getParentRoute: () => rootRouteImport,
  } as any)
const HouseholdsHouseholdIdSettlementsSettlementIdRoute =
  HouseholdsHouseholdIdSettlementsSettlementIdRouteImport.update({
    id: '/households/$householdId/settlements/$settlementId',
    path: '/households/$householdId/settlements/$settlementId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/personvern': typeof PersonvernRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vilkar': typeof VilkarRoute
  '/cards/callback': typeof CardsCallbackRoute
  '/profile/cards': typeof ProfileCardsRoute
  '/households/$householdId/$tab': typeof HouseholdsHouseholdIdTabRoute
  '/households/$householdId/settlements/$settlementId': typeof HouseholdsHouseholdIdSettlementsSettlementIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/personvern': typeof PersonvernRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vilkar': typeof VilkarRoute
  '/cards/callback': typeof CardsCallbackRoute
  '/profile/cards': typeof ProfileCardsRoute
  '/households/$householdId/$tab': typeof HouseholdsHouseholdIdTabRoute
  '/households/$householdId/settlements/$settlementId': typeof HouseholdsHouseholdIdSettlementsSettlementIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/personvern': typeof PersonvernRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vilkar': typeof VilkarRoute
  '/cards/callback': typeof CardsCallbackRoute
  '/profile/cards': typeof ProfileCardsRoute
  '/households/$householdId/$tab': typeof HouseholdsHouseholdIdTabRoute
  '/households/$householdId/settlements/$settlementId': typeof HouseholdsHouseholdIdSettlementsSettlementIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/personvern'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/vilkar'
    | '/cards/callback'
    | '/profile/cards'
    | '/households/$householdId/$tab'
    | '/households/$householdId/settlements/$settlementId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/personvern'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/vilkar'
    | '/cards/callback'
    | '/profile/cards'
    | '/households/$householdId/$tab'
    | '/households/$householdId/settlements/$settlementId'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/personvern'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/vilkar'
    | '/cards/callback'
    | '/profile/cards'
    | '/households/$householdId/$tab'
    | '/households/$householdId/settlements/$settlementId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  PersonvernRoute: typeof PersonvernRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  VilkarRoute: typeof VilkarRoute
  CardsCallbackRoute: typeof CardsCallbackRoute
  ProfileCardsRoute: typeof ProfileCardsRoute
  HouseholdsHouseholdIdTabRoute: typeof HouseholdsHouseholdIdTabRoute
  HouseholdsHouseholdIdSettlementsSettlementIdRoute: typeof HouseholdsHouseholdIdSettlementsSettlementIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vilkar': {
      id: '/vilkar'
      path: '/vilkar'
      fullPath: '/vilkar'
      preLoaderRoute: typeof VilkarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personvern': {
      id: '/personvern'
      path: '/personvern'
      fullPath: '/personvern'
      preLoaderRoute: typeof PersonvernRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/cards': {
      id: '/profile/cards'
      path: '/profile/cards'
      fullPath: '/profile/cards'
      preLoaderRoute: typeof ProfileCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards/callback': {
      id: '/cards/callback'
      path: '/cards/callback'
      fullPath: '/cards/callback'
      preLoaderRoute: typeof CardsCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/households/$householdId/$tab': {
      id: '/households/$householdId/$tab'
      path: '/households/$householdId/$tab'
      fullPath: '/households/$householdId/$tab'
      preLoaderRoute: typeof HouseholdsHouseholdIdTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/households/$householdId/settlements/$settlementId': {
      id: '/households/$householdId/settlements/$settlementId'
      path: '/households/$householdId/settlements/$settlementId'
      fullPath: '/households/$householdId/settlements/$settlementId'
      preLoaderRoute: typeof HouseholdsHouseholdIdSettlementsSettlementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PersonvernRoute: PersonvernRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  VilkarRoute: VilkarRoute,
  CardsCallbackRoute: CardsCallbackRoute,
  ProfileCardsRoute: ProfileCardsRoute,
  HouseholdsHouseholdIdTabRoute: HouseholdsHouseholdIdTabRoute,
  HouseholdsHouseholdIdSettlementsSettlementIdRoute:
    HouseholdsHouseholdIdSettlementsSettlementIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
